import { render, staticRenderFns } from "./IllnessTriage.vue?vue&type=template&id=6993c6a6&"
import script from "./IllnessTriage.vue?vue&type=script&lang=js&"
export * from "./IllnessTriage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports